import s from '../allservices.jsx'

const getUseridService = actionCallback => {
    const cardnumber = localStorage.getItem("cardnumber")
    fetch(s.get_userid + "/" + cardnumber + "/gmcabs" , {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else {
                res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getUseridService;


// WEBPACK FOOTER //
// ./src/services/components/get_userid.jsx